import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <>
      <Header on={'none'} color={'d'}/>
      
      <div className="error-page section-padding bg-section" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-7">
              <div className="error-page-content">
                {/* Visual indicator of a 'broken' path */}
                <h1 style={{ fontSize: '120px', fontWeight: '900', color: '#7a5af8', marginBottom: '10px', lineHeight: '1' }}>404</h1>
                <h2 className="text-anime-style-3" style={{ fontSize: '36px', marginBottom: '20px' }}>Location Unknown</h2>
                
                <p className="wow fadeInUp" style={{ fontSize: '18px', color: '#666', marginBottom: '40px' }}>
                  The page you are looking for doesn't exist or has been moved. 
                  Don't worry, even in unknown territory, we can guide you back to safety.
                </p>

                <div className="error-btn wow fadeInUp" data-wow-delay="0.2s">
                  <Link to="/" className="btn-default">Return to Dashboard</Link>
                  {/* <Link to="/contact" className="btn-default btn-highlighted" style={{marginLeft: '15px'}}>Report an Issue</Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </>
  );
}

export default NotFound;